/**
 * Chart object types and their configurations
 */
import React from "react";
import type { ChartObjectCategory } from "./types";

/** @deprecated use drawing catalog + getEnabledDrawingCategories */
export const CHART_OBJECT_CATEGORIES: ChartObjectCategory[] = [
  {
    name: "Lines",
    objects: [
      {
        type: "vertical-line",
        name: "Vertical line",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <div className="w-0.5 h-5 bg-blue-500"></div>
          </div>
        ),
      },
      {
        type: "horizontal-line",
        name: "Horizontal line",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <div className="w-5 h-0.5 bg-blue-500"></div>
          </div>
        ),
      },
      {
        type: "trendline",
        name: "Trendline",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="15"
                x2="17"
                y2="5"
                stroke="#2196F3"
                strokeWidth="2"
              />
            </svg>
          </div>
        ),
      },
      {
        type: "trend-by-angle",
        name: "Trendline by angle",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center text-blue-500">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 16 L16 4" stroke="#2196F3" strokeWidth="2" />
              <path
                d="M10 4 A6 6 0 0 0 16 10"
                stroke="#2196F3"
                strokeWidth="1.5"
                fill="none"
              />
              <circle cx="13" cy="7" r="1" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Channels",
    objects: [
      {
        type: "equidistant-channel",
        name: "Equidistant channel",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="14"
                x2="12"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="8"
                y1="16"
                x2="17"
                y2="7"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="3"
                y1="14"
                x2="8"
                y2="16"
                stroke="#2196F3"
                strokeWidth="1"
                strokeDasharray="2 2"
              />
              <line
                x1="12"
                y1="5"
                x2="17"
                y2="7"
                stroke="#2196F3"
                strokeWidth="1"
                strokeDasharray="2 2"
              />
            </svg>
          </div>
        ),
      },
      {
        type: "stddev-channel",
        name: "Standard deviation channel",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="10"
                x2="17"
                y2="10"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="3"
                y1="6"
                x2="17"
                y2="6"
                stroke="#2196F3"
                strokeWidth="1"
                strokeDasharray="2 2"
              />
              <line
                x1="3"
                y1="14"
                x2="17"
                y2="14"
                stroke="#2196F3"
                strokeWidth="1"
                strokeDasharray="2 2"
              />
              <circle cx="10" cy="10" r="1" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "regression-channel",
        name: "Regression channel",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M3 15 Q10 10 17 5"
                stroke="#2196F3"
                strokeWidth="1.5"
                fill="none"
              />
              <circle cx="5" cy="14" r="1" fill="#2196F3" />
              <circle cx="8" cy="12" r="1" fill="#2196F3" />
              <circle cx="11" cy="9" r="1" fill="#2196F3" />
              <circle cx="14" cy="8" r="1" fill="#2196F3" />
              <circle cx="16" cy="6" r="1" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "andrews-pitchfork",
        name: "Andrews' pitchfork",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="10"
                y1="5"
                x2="10"
                y2="15"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="5"
                y1="8"
                x2="5"
                y2="15"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="15"
                y1="8"
                x2="15"
                y2="15"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Fibonacci",
    objects: [
      {
        type: "fibonacci-retracement",
        name: "Fibonacci retracement",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="2" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="15" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="15" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="15" width="2" height="2" fill="#2196F3" />
              <text
                x="12"
                y="11"
                fill="#2196F3"
                fontSize="10"
                fontFamily="sans-serif"
              >
                F
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "fibonacci-time-zones",
        name: "Fibonacci time zones",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="2"
                x2="3"
                y2="18"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="2"
                x2="5"
                y2="18"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="18"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="13"
                y1="2"
                x2="13"
                y2="18"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <rect x="2" y="8" width="2" height="2" fill="#2196F3" />
              <rect x="4" y="8" width="2" height="2" fill="#2196F3" />
              <rect x="7" y="8" width="2" height="2" fill="#2196F3" />
              <rect x="12" y="8" width="2" height="2" fill="#2196F3" />
              <text
                x="15"
                y="11"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                F
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "fibonacci-fan",
        name: "Fibonacci fan",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="17"
                x2="17"
                y2="3"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="3"
                y1="17"
                x2="17"
                y2="7"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="17"
                x2="17"
                y2="11"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="17"
                x2="12"
                y2="3"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <text
                x="1"
                y="10"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                F
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "fibonacci-arcs",
        name: "Fibonacci arcs",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M3 17 Q10 12 17 17"
                stroke="#2196F3"
                strokeWidth="1.5"
                fill="none"
              />
              <path
                d="M5 17 Q10 8 15 17"
                stroke="#2196F3"
                strokeWidth="1"
                fill="none"
              />
              <path
                d="M7 17 Q10 5 13 17"
                stroke="#2196F3"
                strokeWidth="1"
                fill="none"
              />
              <text
                x="1"
                y="10"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                F
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "fibonacci-channel",
        name: "Fibonacci channel",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="15"
                x2="12"
                y2="6"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="8"
                y1="17"
                x2="17"
                y2="8"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="5"
                y1="14"
                x2="14"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1"
                strokeDasharray="2 2"
              />
              <text
                x="1"
                y="10"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                F
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "fibonacci-expansion",
        name: "Fibonacci expansion",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="2" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="2" y="15" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="5" y="15" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="6" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="9" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="12" width="2" height="2" fill="#2196F3" />
              <rect x="8" y="15" width="2" height="2" fill="#2196F3" />
              <rect x="11" y="3" width="2" height="2" fill="#2196F3" />
              <rect x="11" y="6" width="2" height="2" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Gann",
    objects: [
      {
        type: "gann-line",
        name: "Gann line",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="17"
                x2="17"
                y2="3"
                stroke="#2196F3"
                strokeWidth="2"
              />
              <text
                x="4"
                y="10"
                fill="#2196F3"
                fontSize="10"
                fontFamily="sans-serif"
              >
                G
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "gann-fan",
        name: "Gann fan",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="5"
                y1="15"
                x2="15"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1.5"
              />
              <line
                x1="5"
                y1="15"
                x2="15"
                y2="8"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="15"
                x2="15"
                y2="11"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="15"
                x2="12"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="15"
                x2="8"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <text
                x="2"
                y="10"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                G
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "gann-grid",
        name: "Gann grid",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="3"
                y1="5"
                x2="17"
                y2="5"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="10"
                x2="17"
                y2="10"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="15"
                x2="17"
                y2="15"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="3"
                x2="5"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="10"
                y1="3"
                x2="10"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <line
                x1="15"
                y1="3"
                x2="15"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1"
              />
              <circle cx="5" cy="5" r="1" fill="#2196F3" />
              <circle cx="10" cy="10" r="1" fill="#2196F3" />
              <circle cx="15" cy="15" r="1" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Shapes",
    objects: [
      {
        type: "rectangle",
        name: "Rectangle",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="3" y="5" width="14" height="10" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "ellipse",
        name: "Ellipse",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <ellipse cx="10" cy="10" rx="8" ry="5" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "triangle",
        name: "Triangle",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 3 L17 15 L3 15 Z" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Symbols & Arrows",
    objects: [
      {
        type: "arrowed-line",
        name: "Arrow",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="4"
                y1="12"
                x2="14"
                y2="6"
                stroke="#2196F3"
                strokeWidth="2"
              />
              <path
                d="M14 6 L11 6 L14 6 L14 9"
                stroke="#2196F3"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </div>
        ),
      },
      {
        type: "signal-arrow-up",
        name: "Arrow up",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 4 L15 12 L5 12 Z" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "signal-arrow-down",
        name: "Arrow down",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 16 L5 8 L15 8 Z" fill="#2196F3" />
            </svg>
          </div>
        ),
      },
      {
        type: "price-label",
        name: "Price label",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="2" y="7" width="16" height="6" fill="#2196F3" rx="1" />
              <text
                x="10"
                y="11"
                fill="white"
                fontSize="8"
                fontFamily="sans-serif"
                textAnchor="middle"
              >
                $
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "cycle-lines",
        name: "Cycle lines",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <line
                x1="5"
                y1="3"
                x2="5"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1.5"
                strokeDasharray="3 3"
              />
              <line
                x1="10"
                y1="3"
                x2="10"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1.5"
                strokeDasharray="3 3"
              />
              <line
                x1="15"
                y1="3"
                x2="15"
                y2="17"
                stroke="#2196F3"
                strokeWidth="1.5"
                strokeDasharray="3 3"
              />
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Text",
    objects: [
      {
        type: "text",
        name: "Text",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <text
                x="10"
                y="13"
                fill="#2196F3"
                fontSize="14"
                fontFamily="sans-serif"
                textAnchor="middle"
              >
                T
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "text-label",
        name: "Text label",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect
                x="2"
                y="6"
                width="16"
                height="8"
                stroke="#2196F3"
                fill="none"
                strokeWidth="1.5"
                rx="1"
              />
              <text
                x="10"
                y="12"
                fill="#2196F3"
                fontSize="10"
                fontFamily="sans-serif"
                textAnchor="middle"
              >
                Abc
              </text>
            </svg>
          </div>
        ),
      },
    ],
  },
  {
    name: "Elliott",
    objects: [
      {
        type: "elliott-motive-wave",
        name: "Elliott impulse wave (12345)",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M2 16 L5 8 L8 14 L11 4 L14 12 L17 6"
                stroke="#2196F3"
                strokeWidth="1.5"
                fill="none"
              />
              <text
                x="8"
                y="18"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                E
              </text>
            </svg>
          </div>
        ),
      },
      {
        type: "elliott-corrective-wave",
        name: "Elliott correction wave (ABC)",
        icon: (
          <div className="w-6 h-6 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M2 8 L6 12 L10 4 L14 12 L18 8"
                stroke="#2196F3"
                strokeWidth="1.5"
                fill="none"
              />
              <text
                x="8"
                y="18"
                fill="#2196F3"
                fontSize="8"
                fontFamily="sans-serif"
              >
                E
              </text>
            </svg>
          </div>
        ),
      },
    ],
  },
];
